import styled from "styled-components";

const TeamStyleWrapper = styled.section`
  background-color: #0d102d;

  .v1_team_overlay {
    position: relative;
    z-index: 1;
    height: 100%;
    width: 100%;
    padding: 110px 0;
  }

  .team_content {
    margin-top: 53px;
    position: relative;
    z-index: 1;
    .row {
      row-gap: 30px;
    }
  }

  @media only screen and (max-width: 768px) {
    .v1_team_overlay {
      padding: 80px 0 85px;
    }
  }

  @media only screen and (max-width: 667px) {
    .v1_team_overlay {
      padding: 60px 0 65px;
    }
  }
`;

export default TeamStyleWrapper;
